import { InformationCircleIcon } from "@heroicons/react/24/outline";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { useTranslation } from "react-i18next";
import { Portal } from "@radix-ui/react-portal";
import { Button } from "@/components/ui/button";

function ProgressHoverCard() {
  const { t } = useTranslation();

  return (
    <HoverCard openDelay={0}>
      <HoverCardTrigger asChild className="hover:cursor-help">
        <Button
          variant="ghost"
          size="icon"
          className="h-5 w-5 p-0 hover:cursor-help"
        >
          <InformationCircleIcon className="h-5 w-5 text-slate-500" />
        </Button>
      </HoverCardTrigger>
      {/* The Portal component renders its children at the root of the document,
       * outside of any parent container's stacking context.
       * This ensures the HoverCard content appears above the ScrollArea's scrollbar,
       * which would otherwise render on top of the HoverCard due to ScrollArea's
       * stacking context.
       */}
      <Portal>
        <HoverCardContent>
          <div className="flex-col-2 text-sm">
            <p className="text-slate-500">{t("edittender.navlinks.progress.hovercard.title")}</p>
            <div className="flex items-center gap-2">
              <div className="rounded-full h-4 w-4 bg-green-400"></div>
              <div className="flex flex-col">
                <div>{t("edittender.navlinks.progress.hovercard.done")}</div>
                <div className="text-xs text-slate-400">{t("edittender.navlinks.progress.hovercard.donedescription")}</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="rounded-full h-4 w-4 bg-yellow-300"></div>
              <div className="flex flex-col">
                <div>{t("edittender.navlinks.progress.hovercard.current")}</div>
                <div className="text-xs text-slate-400">{t("edittender.navlinks.progress.hovercard.currentdescription")}</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="rounded-full h-4 w-4 bg-gray-300"></div>
              <div className="flex flex-col">
                <div>{t("edittender.navlinks.progress.hovercard.upcoming")}</div>
                <div className="text-xs text-slate-400">{t("edittender.navlinks.progress.hovercard.upcomingdescription")}</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <div className="rounded-full h-4 w-4 bg-red-400"></div>
              <div className="flex flex-col">
                <div>{t("edittender.navlinks.progress.hovercard.closed")}</div>
                <div className="text-xs text-slate-400">{t("edittender.navlinks.progress.hovercard.closeddescription")}</div>
              </div>
            </div>
          </div>
        </HoverCardContent>
      </Portal>
    </HoverCard>
  );
}

export default ProgressHoverCard;
